import Vue from "vue";
import Vuex from "vuex";
import {landing, question1} from './assets/data/data'

Vue.use(Vuex);

const initialState = () => {
	return {
		selectedColor: landing.colours,
		backgroundColor: 'rgb(255,255,255)',
		currentQuestion: question1,
		lastQuestion: false,
		interiorOrExterior: '',
		currentPattern: '',
		popupVisible: '',
		resultsListPrimaryColor: null,
		resultsList: [],
		listOrGridView: 'list',
		chosenColor: landing.colours
	}
}

export default new Vuex.Store({
	state: initialState(),
	mutations: {
		updateSelectedColor(state, color) {
			state.selectedColor = new Object(color)
		},
		updateChosenColor(state, color) {
			// This function is so that the chosen colour is kept for the 'one more thing' screen
			//  since the screen needs the selected colour / bg to become white
			state.chosenColor = new Object(color)
		},
		updateBg(state, color) {
			state.backgroundColor = 'rgb('+ color[0] + ',' + color[1] + ',' + color[2] + ')'
		},
		updateCurrentQuestion(state, newQuestion) {
			state.currentQuestion = newQuestion
		},
		isLastQuestion(state, bool) {
			state.lastQuestion = bool
		},
		updatePattern(state, newPattern) {
			state.currentPattern = newPattern
		},
		togglePopup(state, toggle) {
			state.popupVisible = toggle
		},
		updateResultsList(state, list) {
			state.resultsList = list
		},
		updateResultsListPrimaryColor(state, color) {
			state.resultsListPrimaryColor = color
		},
		setInteriorExterior(state, inout) {
			state.interiorOrExterior = inout
		},
		isListOrGridView(state, view){
			state.listOrGridView = view
		},
		resetState(state) {
			Object.assign(state, initialState())
		}
	}
})